export enum FeedbacksActions {
    FETCH_FEEDBACKS = 'FETCH_FEEDBACKS',
    FETCH_SUGGESTIONS = 'FETCH_SUGGESTIONS',
    CREATE_FEEDBACK = 'CREATE_FEEDBACK',
}
